<template>
    <div>
        <h2>落箱-道口操作</h2>
        <van-form @submit="onSubmit">
            <van-field v-model="boxno" name="boxno" maxlength="11" label="箱号" placeholder="箱号" readonly/>
            <van-field v-model="sealno" name="sealno" label="铅封号" placeholder="铅封号" readonly/>
            <van-field v-model="box_model" name="box_model" label="箱型" placeholder="箱型" readonly/>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Dialog, Form} from 'vant';

    Vue.use(Form);

    export default {
        data() {
            return {
                boxno: '',
                sealno: '', box_model: "",
            };
        },
        methods: {
            getBill(boxno) {
                let querystring = require("querystring");
                this.$api.post("wx/container-yard/billInfo",
                    querystring.stringify({
                        boxno: boxno,
                    })
                ).then(({data}) => {
                    if (data.status == 1) {
                        this.sealno = data.data.sealno;
                        this.boxno = data.data.boxno;
                        this.box_model = data.data.box_model;
                    } else {

                    }
                });
            },
            onSubmit(values) {
                console.log('submit', values);
                let querystring = require("querystring");
                this.$api.post("wx/container-yard/bill",
                    querystring.stringify({
                        boxno: values.boxno,
                    })
                ).then(({data}) => {
                    if (data.status == 1) {
                        Dialog.alert({
                            message: '提交成功',
                        }).then(() => {
                            this.$router.push({path: "/container-yard/home"});
                        });
                    } else {
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {
                        });
                    }
                });
            },
        },
        mounted() {
            this.getBill("OOLU9046205");
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/container-yard/bill.vue